ch-tree-view-render {
  display: contents;
}